<template>
    <ListViewTemplate
        view-name="venture"
        :items="ventures"
        :is-loading="isLoading"
        :onClickItem="(item) => onClickItem(item)"
        :getPageData="getVenturesData"
        :toggleSlideover="toggleSlideover"
        :listHeader="ideaHeader"
        :emptyViewBinding="emptyViewBinding"
    >
        <template v-slot:add>
            <AddIdeaSimple
                v-bind="{
                    ...simpleAddIdeaConstants,
                    isShow: isShow,
                    isLoading: false,
                    isSaving: isSaving,
                    formList: simpleForm,
                    modelKey: 'modelField',
                    finalData: formData,
                }"
                @saveForm="(formObject, index) => saveForm(formObject, index)"
                @onClose="
                    () => {
                        isShow = false;
                    }
                "
            />
        </template>
    </ListViewTemplate>
</template>

<script>
import ListViewTemplate from "../components/organisms/ListViewItem/ListViewItem.vue";
import { c } from "../components/constants.js";
import _, { lowerFirst } from "lodash";
import {
    AddIdeaSimple,
    simpleAddIdeaForm,
    simpleAddIdeaConstants,
} from "../components/flows/AddIdeaSimple";
import { form } from "../../.storybook/sampleData";
import { json } from "overmind";
import { Settings } from "../../settings";

export default {
    components: {
        AddIdeaSimple,
        ListViewTemplate,
    },
    data() {
        return {
            isLoading: true,
            isSaving: false,
            isShow: false,
            ideaHeader: {
                title: `Ideas and Ventures ${
                    this.state.venture.ventures.length > 0
                        ? `(${this.state.venture.ventures.length})`
                        : ``
                }`,
                btnText: "Add Idea",
                showSearchbox: false,
            },
            c,
            emptyViewBinding: {
                title: "Get started by adding your first idea!",
                description: "Once your add an idea, it will show up here",
                btnText: "Add an Idea",
                icon: "LightBulbIcon",
            },
            ventures: [],
            form,
            simpleForm: simpleAddIdeaForm,
            simpleAddIdeaConstants,
            venture: null,
            formData: {},
        };
    },

    methods: {
        onClickItem(venture) {
            this.$router.push({
                name: "Venture Dashboard",
                params: { ventureId: venture.id },
            });
        },
        async saveForm(data, index) {
            if (this.isSaving) return false;
            console.log(data, index, "index");
            if (Object.keys(data)?.find((k) => k === "modelField")) {
                delete data.modelField;
            }
            this.isSaving = true;
            try {
                let response = null;
                if (index === 0) {
                    // Step 1: Idea Details
                    this.formData = { ...data };
                } else if (index === 1) {
                    // Step 2: Problem Details
                    this.formData = { ...this.formData, ...data };
                } else if (index === 2) {
                    // Step 3: Summary - Final step
                    console.log(this.formData, "formData");

                    // Create a simple venture with basic information
                    const ventureParam = {
                        name:
                            this.formData?.description?.substring(0, 50) +
                            "...",
                        description: this.formData?.description,
                        users: {
                            connect: [{ id: this.state.currentUser?.id }],
                        },
                        hypotheses: {
                            create: [
                                {
                                    name:
                                        "create " + this.formData?.description,
                                },
                            ],
                        },
                        targetCustomerUsers: {
                            create: [
                                {
                                    name: this.formData?.description,
                                    researchPrompt:
                                        this.formData?.reasonSecond?.label ||
                                        "learn about their experiences",
                                    emailTemplates: {
                                        create: c.emailTemplates,
                                    },
                                    interviewScripts: {
                                        create: [
                                            {
                                                ...c.interviewScript,
                                                createdBy: {
                                                    connect: {
                                                        id: this.state
                                                            .currentUser?.id,
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                    targetCustomer: {
                                        create: {
                                            name: lowerFirst(
                                                this.formData?.description
                                            ),
                                            type: "INDIVIDUALS",
                                        },
                                    },
                                    createdBy: {
                                        connect: {
                                            id: this.state.currentUser?.id,
                                        },
                                    },
                                },
                            ],
                        },
                        opportunities: {
                            create: [
                                {
                                    type: "ACTIVITY",
                                    name: "",
                                    desireText:
                                        this.formData?.reasonFirst?.value,
                                    problemContext: this.formData?.reasonFour,
                                    problems: { connect: [], create: [] },
                                },
                            ],
                        },
                        createdBy: {
                            connect: { id: this.state.currentUser?.id },
                        },
                    };

                    console.log(ventureParam, "param");
                    response = await this.actions.saveFormData({
                        mutation: "saveVenture",
                        params: ventureParam,
                    });

                    const ventures = await this.actions.venture.getVentures({
                        where: { id: response?.id },
                        getValues: true,
                        query: "ventureDetail",
                    });

                    console.log(ventures, "ventures");
                    response = ventures?.[0];

                    // Add Member and Advisor groups
                    const groups = [
                        {
                            name: "Member",
                            description: "Member",
                            isArchive: false,
                            venture: { connect: { id: response?.id } },
                            type: "ROLE",
                            permissions: {
                                create: [
                                    {
                                        type: "data",
                                        name: "Manage Venture",
                                        description: "Venture management",
                                        collection: {
                                            create: {
                                                name: "Venture",
                                            },
                                        },
                                        access: {
                                            create: {
                                                delete: {
                                                    create: {
                                                        access: false,
                                                        mustOwn: true,
                                                    },
                                                },
                                                read: {
                                                    create: {
                                                        access: true,
                                                        mustOwn: false,
                                                    },
                                                },
                                                create: {
                                                    create: {
                                                        access: true,
                                                        mustOwn: true,
                                                    },
                                                },
                                                update: {
                                                    create: {
                                                        access: true,
                                                        mustOwn: false,
                                                    },
                                                },
                                            },
                                        },
                                    },
                                ],
                            },
                        },
                        {
                            name: "Advisor",
                            description: "Advisor",
                            isArchive: false,
                            venture: { connect: { id: response?.id } },
                            type: "ROLE",
                            permissions: {
                                create: [
                                    {
                                        type: "data",
                                        name: "Manage Ventures",
                                        description: "Venture management",
                                        collection: {
                                            create: {
                                                name: "Venture",
                                            },
                                        },
                                        access: {
                                            create: {
                                                delete: {
                                                    create: {
                                                        access: false,
                                                        mustOwn: true,
                                                    },
                                                },
                                                read: {
                                                    create: {
                                                        access: true,
                                                        mustOwn: false,
                                                    },
                                                },
                                                create: {
                                                    create: {
                                                        access: false,
                                                        mustOwn: true,
                                                    },
                                                },
                                                update: {
                                                    create: {
                                                        access: false,
                                                        mustOwn: false,
                                                    },
                                                },
                                            },
                                        },
                                    },
                                ],
                            },
                        },
                    ];

                    groups.map(
                        async (g) =>
                            await this.actions.group.saveGroup({
                                data: g,
                            })
                    );

                    this.isShow = false;
                    this.onClickItem(response);
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.isSaving = false;
            }
        },
        async getVenturesData() {
            this.isLoading = true;
            await this.actions.venture.getVentures({
                orderBy: "createdAt_DESC",
                where: {
                    users_some: {
                        id: this.state.currentUser?.id,
                    },
                },
                all: true,
                query: "venturesList",
            });
            console.log(this.state.venture.ventures, "ventures");
            await this.actions.milestone.getMilestones();

            await this.actions.venture.getTotalVentures();
            Object.values(this.state.venture.ventures)?.map((venture) => {
                const currentMilestone = json(venture?.milestones)?.sort(
                    (a, b) => (a?.sortOrder > b?.sortOrder ? -1 : 1)
                )?.[0];
                this.ventures.push({
                    id: venture.id,
                    title: venture?.name || "",
                    description: venture?.description || "",
                    actionLabel:
                        currentMilestone?.tagLabel || "Getting Started",
                    subtitles: [
                        {
                            icon: "MapIcon",
                            name: "Target Customers",
                            count: venture?.targetCustomerUsers?.filter(
                                (t) => !t?.isArchived
                            )?.length,
                        },
                        {
                            icon: "ExclamationIcon",
                            name: "Opportunities",
                            count: venture?.opportunities?.length,
                        },
                        {
                            icon: "UsersIcon",
                            name: "Team",
                            count: venture?.users?.length,
                        },
                    ],
                });
            });
            this.isLoading = false;
        },
        toggleSlideover(val) {
            this.isShow = val;
        },
    },
    async created() {
        $(document).keydown(function (objEvent) {
            if (objEvent.keyCode == 9) {
                //tab pressed
                objEvent.preventDefault(); // stops its action
            }
        });
        try {
            this.formData.location = [Settings.usObj];
            await this.getVenturesData();
            console.log(this.formData, "formData");
            await this.actions.tag.getTags({
                all: true,
                where: { status: "APPROVED", name_not: "Prefer not to say" },
            });
            const ages = [],
                genders = [],
                incomes = [],
                locations = [],
                ethnicities = [],
                interests = [],
                revenues = [],
                employee_counts = [];
            json(this.state.tag.tags)
                .filter((t) => t.category === "AGE")
                ?.map((t) => {
                    ages.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.category === "GENDER")
                ?.map((t) => {
                    genders.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.category === "INCOME")
                ?.map((t) => {
                    incomes.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.type === "LOCATION")
                ?.map((t) => {
                    locations.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.category === "ETHNICITY")
                ?.map((t) => {
                    ethnicities.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.category === "DESCRIPTORS")
                ?.map((t) => {
                    interests.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.category === "REVENUE")
                ?.map((t) => {
                    revenues.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.category === "EMPLOYEE_COUNT")
                ?.map((t) => {
                    employee_counts.push({ ...t, label: t.name });
                });
            this.form[2].list[1].fields[0].options = JSON.stringify(
                revenues?.sort((a, b) => (a?.sortOrder > b?.sortOrder ? 1 : -1))
            );
            this.form[2].list[2].fields[0].options =
                JSON.stringify(employee_counts);

            this.form[2].list[0].fields[0].options = JSON.stringify(
                interests?.filter((i) => i?.status === "APPROVED")
            );

            this.form[3].list[1].fields[0].options = JSON.stringify(ages);
            this.form[3].list[2].fields[0].options = JSON.stringify(genders);
            this.form[3].list[3].fields[0].options =
                JSON.stringify(ethnicities);
            this.form[3].list[4].fields[0].options = JSON.stringify(incomes);
            this.form[3].list[5].fields[0].options = JSON.stringify(locations);
            this.form[3].list[0].fields[0].options = JSON.stringify(
                interests?.filter((i) => i?.status === "APPROVED")
            );
            await this.actions.actionStep.getActionSteps({ all: true });
            await this.actions.economy.getEconomies({ all: true });
            const economies = [];
            this.state.economy.economies.map((o) =>
                economies?.push({
                    ...o,
                    name: o?.problem,
                    label: o?.problem,
                })
            );
            console.log(economies, "economies");
            const actionSteps = [];
            this.state.actionStep.actionSteps
                ?.filter((a) => a?.status === "APPROVED")
                .map((o) =>
                    actionSteps?.push({
                        ...o,
                        label: o?.name,
                    })
                );
            this.form[4].list[1].fields[0].options =
                JSON.stringify(actionSteps);
            this.form[4].list[2].fields[0].options = JSON.stringify(
                economies?.filter((e) => e?.name)
            );
        } catch (e) {
            console.log(e);
        }
    },
};
</script>
